const clientmodal = {
  title: 'Download Remotemonkey Client'
}

export default clientmodal
